import { Route } from 'react-router-dom';
import { faCode, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MenuManager from '@yooink/youtils/es/MenuManager';
import { LoadComponent } from '@yooink/youtils/es/LoadComponent';
import { FaPalette, FaUser } from 'react-icons/fa';
import { DiNodejsSmall, DiRedis } from 'react-icons/di';
import { addPropsToComponent } from '@yooink/youtils/es/AddPropsToComponent';
import { MdTranslate } from 'react-icons/md';
import { SuperUsersRoute } from './Users/SuperUsersRoute';
import UISettings from './UISettings';
import LocalizationManager from './LocalizationManager';
import I18nEditor from './LocalizationManager/I18nEditor';

MenuManager.RegisterGroup({
	key: 'system',
	name: 'Система',
	icon: <FontAwesomeIcon icon={faPowerOff} />,
	position: 99
}, [{
	path: '/system/localization',
	name: 'Центр локализации контента',
	icon: <MdTranslate />
}, {
	path: '/system/profile',
	name: 'Профиль пользователя',
	icon: <FaUser />
}, {
	path: '/system/bull',
	name: 'Менеджер очереди',
	icon: <DiRedis />
}, {
	icon: <FontAwesomeIcon icon={faCode} />,
	path: '/system/siteSettings',
	name: 'Настройки сайта (Прямой доступ)'
}, {
	icon: <FaUser />,
	path: '/system/users',
	name: 'Пользователи панели администрирования'
}, {
	icon: <DiNodejsSmall />,
	path: '/system/maintenanceScripts',
	name: 'Скрипты обслуживания'
}, {
	icon: <FontAwesomeIcon icon={FaPalette} />,
	path: '/system/ui',
	name: 'UI'
}]);

const SiteSettings = LoadComponent(() => import('./SiteSettings'));
const MaintenanceScripts = LoadComponent(() => import('./MaintenanceScripts/maintainceScriptsRoute'), 'MaintainceScriptsRoute');
const Profile = LoadComponent(() => import('./Profile'));

const System = () => (
	<Route
		path="/system"
		render={() => (
			<>
				<Route exact path="/system/profile" component={Profile} />
				<Route exact path="/system/siteSettings" component={SiteSettings} />
				<Route exact path="/system/ui" component={UISettings} />
				<Route
					path="/system/maintenanceScripts"
					component={addPropsToComponent({
					path: '/system/maintenanceScripts'
				}, MaintenanceScripts)}
				/>

				<Route exact path="/system/localization" component={LocalizationManager} />
				<Route exact path="/system/localization/i18n" component={I18nEditor} />

				<SuperUsersRoute />
			</>
		)}
	/>
);

export default System;
